
import NavBarItems from '@/components/Shared/Header/NavItems.json'
export default {
  data() {
    return {
      navItems: NavBarItems[4],
    }
  },
}
